import { ReactNode } from "react";

import { ToastVariant } from "common/enums";
import { SignalRMessage } from "common/services/signalr-service";
import homeLabelCollection from "modules/home/config/langauge-keys.config";
import {
  hasServiceNowEngagementAccess
} from "modules/home/util/grc.util";

import labelCollection from "../config/langauge-keys.config";
import { EngagementFeatureAccess } from "../config/engagement-access-config";

type Translate = (key: string, options?: Record<string, unknown>) => string;

type GrcSyncToastDetails = {
  isVisible: true;
  message: ReactNode;
  type: ToastVariant;
};

export const GrcSyncToastDetails = (
  message: SignalRMessage | null,
  t: Translate,
  engagementAccess: EngagementFeatureAccess
): GrcSyncToastDetails | null => {
  if (!message) {
    return null;
  }

  const responseText =
    (message as unknown as { message?: string }).message || "";

  const grcName =
    hasServiceNowEngagementAccess(engagementAccess)
    ? t(homeLabelCollection.grcProviderServiceNow)
    : t(homeLabelCollection.grcProviderOptro);

  const isGrcSyncFailed =
    responseText.toLowerCase() ===
    t(labelCollection.grcSyncFailedMessage, { grcName }).toLowerCase();

  return {
    isVisible: true,
    message: isGrcSyncFailed ? (
      <>
        {t(labelCollection.engagementGrcSyncFailed, { grcName })}
        <br />
        <span className="optro-sync-toast__subtitle">
          {t(labelCollection.clickRetryGrcSyncToTryAgain, { grcName })}
        </span>
      </>
    ) : (
      responseText
    ),
    type: isGrcSyncFailed ? ToastVariant.WARNING : ToastVariant.SUCCESS
  };
};
